const translator = {
  esp: 'Traduko de T. Auderskaja'
};
export default translator;